import { Injectable } from '@angular/core';
import { ColDef, GridOptions, GridApi, ColumnApi, FirstDataRenderedEvent } from 'ag-grid-community';
import { AgGridServicesWrapperService } from '@shared/ag-grid/services-wrapper.service';
import { BaseAgGridSettingsService } from '@shared/ag-grid/base-ag-grid-settings.service';
import { GridState } from '@shared/ag-grid/gird-state';
import { CellButtonComponent } from '@shared/ag-grid/component/cell-button/cell-button.component';
import { CellContentClipboardComponent } from '@shared/ag-grid/component/cell-content-clipboard/cell-content-clipboard.component';
import { scoreBuilder } from '@program/shared/evaluations-admin-all/helpers/score-builder';
import { CELL_STYLES } from '@program/shared/evaluations-admin-all/constants/cell-styles';

@Injectable()
export class EvaluationsDisplayGridSettingService extends BaseAgGridSettingsService {
  _columnApi: ColumnApi;
  _gridApi: GridApi;
  _gridStateStorageKey: string;
  currentGridState: GridState = new GridState();
  defaultGridState: GridState = new GridState();
  initialGridState: GridState = new GridState();

  private columns = {};
  private pass = {};
  private fail = {};

  constructor(_agGridServicesWrapperService: AgGridServicesWrapperService) {
    super(_agGridServicesWrapperService);
    this.columns = _agGridServicesWrapperService._translateService.instant('program.configuration.evaluation-display.columns');
    this.pass = _agGridServicesWrapperService._translateService.instant('program.evaluation.PASS');
    this.fail = _agGridServicesWrapperService._translateService.instant('program.evaluation.FAIL');
  }

  getGridOptions(): GridOptions {
    return <GridOptions>{
      columnDefs: this.getColumnSetting(),
      components: {
        cellButtonComponent: CellButtonComponent,
        cellContentClipboardComponent: CellContentClipboardComponent
      },
      rowClass: 'row-with-tags',
      sortable: false,
      suppressMenu: true,
      suppressRowClickSelection: true,
      domLayout: 'autoHeight',
      onFirstDataRendered: (params: FirstDataRenderedEvent<any>) => {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
      }
    };
  }

  private getColumnSetting(): ColDef[] {
    return [
      {
        field: 'updated',
        headerName: this.columns['evaluation-date'],
        headerTooltip: this.columns['evaluation-date'],
        width: 70,
        wrapText: true,
        autoHeight: true,
        cellStyle: CELL_STYLES,
        cellRenderer: (params) => {
          return this.getLocalDate({value: params.value}, 'dd MMMM yyyy HH:mm');
        }
      },
      {
        field: 'evaluationConfig.name',
        headerName: this.columns['criteria'],
        headerTooltip: this.columns['criteria'],
        width: 70,
        wrapText: true,
        autoHeight: true,
        cellStyle: CELL_STYLES
      },
      {
        field: 'scoreValue',
        headerName: this.columns['score'],
        headerTooltip: this.columns['score'],
        width: 70,
        wrapText: true,
        autoHeight: true,
        cellStyle: CELL_STYLES,
        cellRenderer: (params) => scoreBuilder(params?.data, this.pass, this.fail)
      },
      {
        field: 'comments',
        headerName: this.columns['comments'],
        headerTooltip: this.columns['comments'],
        width: 250,
        autoHeight: true,
        wrapText: true,
        cellRenderer: 'cellContentClipboardComponent',
        flex: 1,
        cellStyle: CELL_STYLES
      },
    ];
  }
}
